import { ProjectFormType } from '../hooks/useCreateProject';
import { DynamicField, DynamicFieldResponse } from '../models/form';

const hasNoValue = (value: unknown): boolean =>
    value === undefined || value === null || value === '';

export const mapCreateProjectFormField = (
    field: DynamicFieldResponse,
    projectCustomFields?: Record<string, unknown>,
): DynamicField<ProjectFormType> => {
    return {
        ...field,
        selectOptions: field.options || [],
        name: `packageCustomField.${field.name}`,
        pattern: field.pattern ? new RegExp(field.pattern) : undefined,
        isEditablePostCreation: hasNoValue(projectCustomFields?.[field.name]),
    };
};
